import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

import '../style.css'

export default function StatusPopover() {
  const popover = (
    <Popover style={{ maxWidth: "350px" }}>
      <Popover.Title as="h3" className="font-weight-bold">Status</Popover.Title>
      <Popover.Content>
        <p className='mb-1'>
          <i className="far fa-envelope-open text-success fa-lg pt-3  pl-2 pr-3" aria-hidden="true"></i> Message is unread until responded to.
          <div className='notification__static__dot' />
        </p>
        <p><i className="far fa-envelope-open text-success fa-lg pl-2 pr-3" aria-hidden="true"></i> Message is open for communication.</p>
        <p><i className="far fa-envelope text-danger fa-lg pl-2 pr-3" aria-hidden="true"></i> Message is closed for communication.</p>
      </Popover.Content>
    </Popover>
  )

  return (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
      <div className="statusQuestion">
        <i className="fa fa-question-circle" style={{ fontSize: "1.5em" }}></i>
      </div>
    </OverlayTrigger>
  )
}
